import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Compass, Quote } from 'lucide-react';

const FounderPage = () => {
  const { i18n } = useTranslation();
  const isFr = i18n.language === 'fr';

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-primary to-orange-600 text-white py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              {isFr ? 'Le Fondateur' : 'The Founder'}
            </h1>
            <p className="text-xl text-white/90">
              {isFr 
                ? 'L\'histoire derrière XPerience' 
                : 'The story behind XPerience'}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Founder Section */}
      <section className="py-16 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="bg-white rounded-3xl shadow-lg overflow-hidden"
            >
              <div className="md:flex">
                {/* Photo */}
                <div className="md:w-2/5 bg-gradient-to-br from-orange-100 to-orange-50 p-8 flex items-center justify-center">
                  <div className="relative">
                    <img 
                      src="https://customer-assets.emergentagent.com/job_dd108869-396c-41df-bff4-71dd44394bff/artifacts/lnedluqo_IMG_20220818_112733.jpg"
                      alt="Steve - Fondateur de XPerience"
                      className="w-full h-64 md:h-80 object-cover rounded-2xl shadow-xl"
                    />
                    <div className="absolute -bottom-3 -right-3 bg-white rounded-full p-2 shadow-lg">
                      <Compass className="w-8 h-8 text-primary" />
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="md:w-3/5 p-8 md:p-10">
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">Steve</h2>
                  
                  <div className="prose prose-lg text-gray-600 space-y-4">
                    <p>
                      {isFr 
                        ? 'Voyageur passionné, j\'ai vécu pas mal d\'années à sillonner les routes de l\'Europe en van et à faire des rencontres incroyables. Alors j\'ai compris une chose : ce sont les gens qui font le voyage, pas les lieux. Aussi, j\'ai réalisé une autre chose essentielle : lorsque tu rencontres des locaux et qu\'ils ont plaisir à te faire découvrir leurs régions, leurs passions, leurs secrets, et bien là, tu touches quelque chose d\'unique, de vivant !'
                        : 'A passionate traveler, I spent many years roaming the roads of Europe in a van and making incredible encounters. So I understood one thing: it\'s the people who make the journey, not the places. I also realized something else essential: when you meet locals and they enjoy showing you their regions, their passions, their secrets, well, that\'s when you touch something unique, something alive!'}
                    </p>
                    
                    <div className="bg-orange-50 rounded-xl p-5 my-6">
                      <Quote className="w-5 h-5 text-primary mb-2" />
                      <p className="text-gray-700 italic">
                        {isFr
                          ? 'Paradoxalement, l\'idée de XPerience m\'est venue avant même de partir, quand j\'étais encore enfermé dans un bureau à rêver d\'aventure. Aujourd\'hui, je vis ce rêve, je veux le partager et que vous partagiez, vous aussi, des instants incroyables.'
                          : 'Paradoxically, the idea for XPerience came to me before I even left, when I was still stuck in an office dreaming of adventure. Today, I\'m living that dream and I want to share it, and for you to share incredible moments too.'}
                      </p>
                    </div>

                    <p>
                      {isFr
                        ? 'Ma plus grande satisfaction ? Savoir que grâce à XPerience, des voyageurs et des locaux se rencontreront et créeront ensemble des souvenirs inoubliables.'
                        : 'My greatest satisfaction? Knowing that thanks to XPerience, travelers and locals will meet and create unforgettable memories together.'}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FounderPage;
